/**
 * Created by Abner Sui on 05/20/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AgGridModule } from 'ag-grid-angular';
import { EffectsModule } from '@ngrx/effects';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { TooltipModule } from '@progress/kendo-angular-tooltip';

import { WidgetsModule } from '../../widgets/widgets.module';
import { FileViewComponent } from './file-view.component';
import { ThreadDetailModule } from '../../components/thread-detail/thread-detail.module';
import { FileViewEffects } from '../../redux/effects/file-view.effects';
import { TopFileListComponent } from '../../components/top-file-list/top-file-list.component';

@NgModule({
    imports: [
        AgGridModule,
        CommonModule,
        WidgetsModule,
        DropDownsModule,
        InfiniteScrollModule,
        TooltipModule,
        ThreadDetailModule,
        EffectsModule.forFeature([
            FileViewEffects,
        ]),
    ],
    declarations: [
        TopFileListComponent,
        FileViewComponent,
    ],
    exports: [
        FileViewComponent,
    ]
})
export class FileViewModule { }
